import React,{ useState } from 'react'
import { useEffect } from 'react'
import axios from 'axios'
import { showSuccess, showError } from '../toast';
import ReactPaginate from 'react-paginate';
import { FcCallback } from "react-icons/fc";
import { FaSearch, FaPhoneAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { maskNumber, useCampaignMask } from '../phoneMask';


const Callback = () => {
  // Number masking from the agent's campaign (AddCampaign → Masking).
  const maskRule = useCampaignMask();
    const navigate = useNavigate();
    const [posts, setAllPosts] = useState([]);
    const [offset, setOffset] = useState(1);
    const [pageCount, setPageCount] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [numbersearch, setNumbersearch] = useState('NA');

    const getAllPosts = async () => {
        try {
            const res = await axios.get(process.env.REACT_APP_IP + `/User/TodayCallBack?searchnumber=${numbersearch}&pageNumber=${offset - 1}&size=${pageSize}`, { withCredentials: true })
            const data = res.data;
            const postData = getPostData(data)
            setAllPosts(postData)
            setPageCount((data.page?.totalPages ?? data.totalPages ?? 0))
        } catch (e) { console.error('getAllPosts:', e) }
    }

    useEffect(() => {
        getAllPosts()
    }, [offset, pageSize, maskRule])

    useEffect(() => {
        document.title = "Today Callbacks"
    }, []);

    const searchNumber = (e) => {
        e.preventDefault()
        getAllPosts()
    }

    const goToAllCallbackPage = () => {
        navigate('/Callbackall');
    };

    const callBackFun = async (e, e2) => {
        try {
            var formdata = new FormData()
            formdata.append('number', e)
            formdata.append('callbackid', e2)
            const response = await fetch(process.env.REACT_APP_IP + "/User/CallBack", {
                method: 'POST', credentials: 'include', body: formdata
            });
            const json = await response.json()
            if (json.type === "OK") showSuccess(json.msg); else showError(json.msg)
        } catch (e) { console.error('callBackFun:', e) }
    }

    const onInputChange = (event) => {
        const offset = Math.ceil(event.target.value);
        setOffset(offset);
    }

    const handlePageClick = (event) => {
        const selectedPage = event.selected;
        setOffset(selectedPage + 1)
    }

    const getPostData = (data) => {
        return (
            <div className="cb-table-wrap">
                <table className="cb-table">
                    <thead>
                        <tr>
                            <th>Lead ID</th>
                            <th>Customer Number</th>
                            <th>Customer Name</th>
                            <th>Action</th>
                            <th>Attempted</th>
                            <th>Scheduled Time</th>
                            <th>Remarks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(data?.content ?? []).map(page => (
                            <tr key={page.id}>
                                <td><span className="cb-lead-id">#{page.id}</span></td>
                                <td><strong>{maskNumber(page.custnumber, maskRule)}</strong></td>
                                <td>{page.name || '—'}</td>
                                <td>
                                    <button className="cb-call-btn" onClick={() => callBackFun(page.custnumber, page.id)} title="Call back">
                                        <FaPhoneAlt size={11} /> Call
                                    </button>
                                </td>
                                <td>
                                    <span className={`cb-attempt-badge ${page.flag === 1 ? 'cb-attempt-yes' : 'cb-attempt-no'}`}>
                                        {page.flag === 1 ? 'Yes' : 'No'}
                                    </span>
                                </td>
                                <td>{page.callbacktime}</td>
                                <td>
                                    <div className="cb-remarks">{page.remarks || '—'}</div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <div className="fr-wrapper">
            <div className="cb-page">
                <div className="rt-card">
                    <div className="dash-card-header d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <FcCallback className="me-2" size={18} />
                            Today's Callbacks
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <form onSubmit={searchNumber} className="cb-search-form">
                                <input
                                    type="text"
                                    className="cb-search-input"
                                    placeholder="Search number..."
                                    onChange={(e) => setNumbersearch(e.target.value)}
                                />
                                <button type="submit" className="cb-search-btn"><FaSearch size={12} /></button>
                            </form>
                            <button className="cb-all-btn" onClick={goToAllCallbackPage}>All Callbacks</button>
                        </div>
                    </div>
                    <div className="rt-card-body" style={{padding: '0'}}>
                        {posts}
                    </div>
                </div>

                <div className="cb-footer">
                    <div className="cb-footer-left">
                        <div className="cb-rows-select">
                            <span>Rows:</span>
                            <select value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); setOffset(1); }}>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>
                        <div className="cb-goto">
                            <span>Page:</span>
                            <input type="text" className="cb-goto-input" placeholder="#" onChange={onInputChange} />
                        </div>
                    </div>
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        breakLinkClassName={"break-mef"}
                        pageCount={pageCount}
            pageRangeDisplayed={10}
            marginPagesDisplayed={1}
                        onPageChange={handlePageClick}
                        forcePage={offset - 1}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                    />
                </div>
            </div>
        </div>
    )
}

export default Callback
